export const ALLSERVICES_page = {
    roiInvestorBenefits: {
        sectionId: "overview",
        title: "Experience Luxury & Reliability Across All Our Services",
        subtitle:
            "Make journey comfortable with",
        image: {
            src: "/img/services/section2.svg",
            alt: "RSL-Purchased Vehicle"
        },
        services: [
            {
                "image": "/img/services/card/airport.svg",
                "name": "Airport Transfers",
                "href": "/rides"
            },
            {
                "image": "/img/services/card/corporate.svg",
                "name": "Corporate Travel",
                "href": "/rides"
            },
            {
                "image": "/img/services/card/hourly.svg",
                "name": "Hourly Car Booking",
                "href": "/hourly"
            },
            {
                "image": "/img/services/card/investment.svg",
                "name": "RSL Investment",
                "href": "/investments/investments"
            },
            // {
            //     "image": "/img/services/card/tour.svg",
            //     "name": "Tour & Activities",
            //     "href": "/activities"
            // },
            {
                "image": "/img/services/card/hotel.svg",
                "name": "Hotel Reservations"
            },
            // {
            //     "image": "/img/services/card/holiday.svg",
            //     "name": "Holiday Packages",
            //     "href": "/packages"
            // },
            {
                "image": "/img/services/card/jet.svg",
                "name": "Private Jet Chartering"
            }
        ],
        bgcolor: "#ffffff",
        width: "100%",
        button: { text: "Contact Us", href: "/contact-us" },
    },
    carToInvestNew: {
        sectionId: "carToInvestNew",
        title: "RSL Fleets Preview",
        subtitle:
            "Make journey comfortable with",
        filters: ["Popular Car", "Sedan", "SUV's"],
        type: "services",
        button: { text: "Book Now", href: "/carBooking/carBookRide?rideBooking=true" },
    },
    carToInvest: {
        sectionId: "Make journey comfortable with",
        title: "Why Choose RSL",
        subtitle:
            "Make journey comfortable with",
        image: {
            src: "/img/services/section3.svg",
            alt: " Hands offering coins"
        },
        // button: { text: "Let's work together", link: "#" },
        bgcolor: "#fff",
    },
    communicationChannel: {
        sectionId: "communicationChannel",
        image: {
            src: "/images/bannerImage/rsl_super_app.svg",
            alt: "RSL SUPER APP"
        }
    },
}